import * as React from 'react';

import { cn } from '../../lib/cn';

export interface TelemetryPanelFrameProps {
	/** Titolo della sezione. Default: "Curva di carico". */
	title?: React.ReactNode;
	/** Se true, mostra il badge "Live"; altrimenti mostra il badge di simulazione. */
	live: boolean;
	/** Testo del badge quando `live` è true. Default: "● Live". */
	liveLabel?: React.ReactNode;
	/** Testo del badge quando `live` è false. Default: "Simulazione". */
	simulationLabel?: React.ReactNode;
	/** Riga di stato della sorgente dati, allineata a destra; mostrata solo se presente. */
	statusText?: React.ReactNode;
	/** Contenuto della sezione (tipicamente un grafico). */
	children: React.ReactNode;
	/**
	 * Azione in testata, es. l'esploso per POD. Questo pannello mostra un solo
	 * punto di misura e una sola direzione: l'esploso è dove si vede il punto di
	 * connessione per intero, con l'altra direzione accanto.
	 */
	action?: React.ReactNode;
}

/** Cornice a card per una sezione di telemetria del misuratore: titolo, badge live/simulazione, stato sorgente, contenuto. */
const TelemetryPanelFrame = ({
	title = 'Curva di carico',
	live,
	liveLabel = '● Live',
	simulationLabel = 'Simulazione',
	statusText,
	children,
	action,
}: TelemetryPanelFrameProps) => (
	<div className="space-y-3 rounded-xl border border-border bg-card p-4">
		<div className="flex flex-wrap items-center justify-between gap-2">
			<div className="flex items-center gap-2">
				<span className="text-[13px] font-bold uppercase tracking-wider text-text">{title}</span>
				<span
					className={cn(
						'rounded-full px-2 py-0.5 text-[11px] font-bold uppercase',
						live ? 'bg-accent-green/15 text-accent-green' : 'bg-border text-text-muted',
					)}
				>
					{live ? liveLabel : simulationLabel}
				</span>
			</div>
			<div className="flex items-center gap-2">
				{statusText && <span className="text-[11px] text-text-muted">{statusText}</span>}
				{action}
			</div>
		</div>
		{children}
	</div>
);
TelemetryPanelFrame.displayName = 'TelemetryPanelFrame';

export { TelemetryPanelFrame };
